import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, Flex, Typography, Grid } from 'antd';
import { useState, useEffect } from 'react';

import type { LoyaltyCardTabProps } from '@app/components/RecordModal/components/RecordPayment/types';
import {
  CardItem,
  ConfirmCancelPaymentWithBonusesModal,
} from '@app/components/RecordModal/components/RecordPayment/ui';

const { useBreakpoint } = Grid;

const { Text } = Typography;

export const LoyaltyCardTab: React.FC<LoyaltyCardTabProps> = ({
  card,
  cardBonusesInfo,
  recordId,
  servicesTableData,
  getRecordInfoHandler,
  totalPaid,
  initTable,
  fetchPayments,
  calculateBonusesToEarn,
  activeKey,
}) => {
  const screens = useBreakpoint();
  const isMobileOrTablet = !screens.lg;

  const [
    isConfirmCancelPaymentWithBonusesModalOpen,
    setIsConfirmCancelPaymentWithBonusesModalOpen,
  ] = useState(false);

  const handleCancelPaymentWithBonuses = () => {
    setIsConfirmCancelPaymentWithBonusesModalOpen(true);
  };

  useEffect(() => {
    if (
      activeKey === card.id &&
      card.type === 'bonus' &&
      !cardBonusesInfo?.CardId
    ) {
      calculateBonusesToEarn(card.id);
    }
  }, [
    activeKey,
    card.id,
    card.type,
    calculateBonusesToEarn,
    cardBonusesInfo?.CardId,
  ]);

  return (
    <>
      <Flex vertical gap={12}>
        {cardBonusesInfo?.CardId && (
          <Text type="success">
            Вы уже применили данную карту лояльности и не можете переключиться
            на другую. Для этого необходимо отменить применение текущей карты.
          </Text>
        )}

        <Flex gap={20} vertical={isMobileOrTablet} align="stretch">
          <CardItem
            card={card}
            recordId={recordId}
            servicesTableData={servicesTableData}
            bonusesToExceed={cardBonusesInfo?.BonusesToExceed}
            appliedCardId={cardBonusesInfo?.CardId}
            getRecordInfoHandler={getRecordInfoHandler}
            totalPaid={totalPaid}
            initTable={initTable}
            fetchPayments={fetchPayments}
          />

          {card.type === 'bonus' && (
            <Flex gap={20} style={{ flex: 1 }}>
              <Flex vertical gap={10}>
                <Text>Списано бонусов</Text>
                <Flex justify="space-between" align="center">
                  <Text type="danger">
                    - {cardBonusesInfo?.BonusesToExceed || 0} бонусов
                  </Text>
                  {cardBonusesInfo?.CardId && (
                    <Button
                      icon={<CloseCircleOutlined />}
                      size="small"
                      onClick={handleCancelPaymentWithBonuses}
                    />
                  )}
                </Flex>
              </Flex>

              <Flex vertical gap={10}>
                <Text>Начислится бонусов</Text>
                <Text type="success">
                  + {cardBonusesInfo?.BonusesToEarn || 0} бонусов
                </Text>
              </Flex>
            </Flex>
          )}

          {card.type === 'discount' && cardBonusesInfo?.CardId && (
            <Button
              icon={<CloseCircleOutlined />}
              onClick={handleCancelPaymentWithBonuses}
              disabled={totalPaid > 0}
              style={{ width: isMobileOrTablet ? '100%' : 'auto' }}
            >
              Отменить применение скидочной карты
            </Button>
          )}
        </Flex>
      </Flex>

      <ConfirmCancelPaymentWithBonusesModal
        isOpen={isConfirmCancelPaymentWithBonusesModalOpen}
        setIsOpen={setIsConfirmCancelPaymentWithBonusesModalOpen}
        recordId={recordId}
        getRecordInfoHandler={getRecordInfoHandler}
        initTable={initTable}
        fetchPayments={fetchPayments}
      />
    </>
  );
};
